import { render, staticRenderFns } from "./ChangeTodoDialog.vue?vue&type=template&id=71e6e8c0"
import script from "./ChangeTodoDialog.vue?vue&type=script&lang=js"
export * from "./ChangeTodoDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeTodoDialog.vue?vue&type=style&index=0&id=71e6e8c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports